import React from 'react';
import { Link } from 'react-router-dom';

import IzendaIntegrate from '../../helper/IzendaIntegrate';
import {Indicator} from '../../components/indicators/indicator';

let interval = null;
let dom = null;

class IzendaDashboards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true
    };
  }

  componentDidMount() {
    interval = setInterval(() => {
      if (window.IzendaSynergy) {
        dom = IzendaIntegrate.RenderDashboard(this.hideLoading);

        clearInterval(interval);

      }
    }, 1000);
  }

  componentWillUnmount() {
    IzendaIntegrate.DestroyDom(dom);
  }

  hideLoading = () => {
    this.setState({ isLoading: false });
  }

  render() {
    return <div>
      {
        this.state.isLoading && <Indicator id='setting-loading' show={true} />
      }
      <div className='page-title clearfix'>
        <h2 className='pull-left'>Dashboards</h2>
        <Link className='btn btn-primary btn-info btn-siteone pull-right btn-icon' to='/report-dashboards/new' ><span className='fa fa-plus icon' />NEW</Link>
      </div>
      <div className='izenda-container' id='izenda-root-dashboard' style={{height: 1000}} />
    </div>;
  }
}

export default IzendaDashboards;



// WEBPACK FOOTER //
// ./src/izenda/containers/dashboards.js